/**
 * Búsqueda dinámica dentro de la colección principal de Balper.
 */
(() => {
  const CLAVE_REGRESO = 'balperPaginaCatalogo';

  function iniciarCatalogoBalper(formulario) {
    if (!formulario || formulario.dataset.balperIniciado === 'true') {
      return;
    }

    const campo = formulario.querySelector('input[name="q"]');
    const botonBuscar = formulario.querySelector('.buscador-catalogo__boton');
    const botonCompartir = formulario.querySelector('[data-compartir-catalogo]');
    const estado = formulario.querySelector('[data-estado-busqueda]');

    if (!campo || !botonBuscar || !botonCompartir || !estado) {
      return;
    }

    formulario.dataset.balperIniciado = 'true';

    const RUTA_BUSQUEDA = formulario.dataset.searchUrl;
    const RUTA_CATALOGO = formulario.dataset.catalogUrl;

    let numeroSolicitud = 0;
    let terminoActivo = '';

    function obtenerElementosCatalogo() {
      const contenedor = document.querySelector('#ProductGridContainer');
      const cuadricula =
        contenedor?.querySelector('ul#product-grid') ||
        contenedor?.querySelector('ul.product-grid') ||
        document.querySelector('ul#product-grid');
      const seccion = contenedor?.closest('.shopify-section') || contenedor;

      return { contenedor, cuadricula, seccion };
    }

    function obtenerTerminoURL() {
      return new URL(window.location.href).searchParams.get('buscar')?.trim() || '';
    }

    function hayFiltrosEnURL(url = new URL(window.location.href)) {
      return Array.from(url.searchParams.keys()).some((nombre) =>
        nombre.startsWith('filter.')
      );
    }

    function crearURLCatalogoNavegacion(termino = '') {
      const actual = new URL(window.location.href);
      const destino = new URL(RUTA_CATALOGO, window.location.origin);

      ['preview_theme_id', '_fd', 'pb'].forEach((nombre) => {
        if (actual.searchParams.has(nombre)) {
          destino.searchParams.set(nombre, actual.searchParams.get(nombre));
        }
      });

      if (termino) {
        destino.searchParams.set('buscar', termino);
      }

      return destino;
    }

    function crearURLPublicaActual() {
      const actual = new URL(window.location.href);
      const publica = new URL(
        botonCompartir.dataset.url || RUTA_CATALOGO,
        window.location.origin
      );
      const termino = actual.searchParams.get('buscar')?.trim() || '';

      if (termino) {
        publica.searchParams.set('buscar', termino);
        return publica;
      }

      actual.searchParams.forEach((valor, nombre) => {
        if (nombre.startsWith('filter.') || nombre === 'sort_by') {
          publica.searchParams.append(nombre, valor);
        }
      });

      return publica;
    }

    function guardarPaginaActual() {
      const url = crearURLPublicaActual();
      const tieneSeleccion = obtenerTerminoURL() || hayFiltrosEnURL();

      if (tieneSeleccion) {
        sessionStorage.setItem(CLAVE_REGRESO, url.href);
      } else {
        sessionStorage.removeItem(CLAVE_REGRESO);
      }
    }

    function actualizarBotonCompartir() {
      const haySeleccion = obtenerTerminoURL() || hayFiltrosEnURL();

      botonCompartir.textContent = haySeleccion
        ? '\u2197 Compartir selección'
        : '\u2197 Compartir catálogo';
    }

    function modificarContador(seccion, texto) {
      if (!seccion) return;

      seccion
        .querySelectorAll('#ProductCountDesktop, #ProductCount')
        .forEach((contador) => {
          const textoContador =
            contador.querySelector('.product-count__text') || contador;
          textoContador.textContent = texto;
        });
    }

    function agregarBotonesProductos(cuadricula) {
      if (!cuadricula) return;

      cuadricula.querySelectorAll(':scope > li').forEach((producto) => {
        producto
          .querySelectorAll('.boton-producto-busqueda')
          .forEach((botonAnterior) => botonAnterior.remove());

        if (producto.querySelector('.quick-add, product-form')) {
          return;
        }

        const enlaceProducto = producto.querySelector('a[href*="/products/"]');
        if (!enlaceProducto) return;

        const boton = document.createElement('a');
        boton.className = 'boton-producto-busqueda';
        boton.href = enlaceProducto.getAttribute('href');
        boton.textContent = 'Seleccionar opciones';

        const precio =
          producto.querySelector('.card-information .price') ||
          producto.querySelector('.card__information .price') ||
          producto.querySelector('.price');

        if (precio) {
          precio.insertAdjacentElement('afterend', boton);
        } else {
          const contenidos = producto.querySelectorAll('.card__content');
          const destino = contenidos[contenidos.length - 1] || producto;
          destino.appendChild(boton);
        }
      });
    }

    function obtenerPaginacionBusqueda(seccion, cuadricula) {
      let paginacion = seccion?.querySelector('.busqueda-paginacion');
      if (paginacion) return paginacion;

      paginacion = document.createElement('div');
      paginacion.className = 'busqueda-paginacion';

      const paginacionOriginal = seccion?.querySelector('.pagination-wrapper');

      if (paginacionOriginal) {
        paginacionOriginal.insertAdjacentElement('afterend', paginacion);
      } else {
        cuadricula.insertAdjacentElement('afterend', paginacion);
      }

      return paginacion;
    }

    async function cargarBusqueda(url, termino) {
      const elementos = obtenerElementosCatalogo();
      const { cuadricula, seccion } = elementos;

      if (!cuadricula || !seccion) {
        estado.textContent = 'No se encontró la cuadrícula de productos.';
        return;
      }

      const solicitudActual = ++numeroSolicitud;
      terminoActivo = termino;
      const paginacionBusqueda = obtenerPaginacionBusqueda(seccion, cuadricula);
      const paginacionOriginal = seccion.querySelector('.pagination-wrapper');

      cuadricula.classList.add('busqueda-cargando');
      cuadricula.setAttribute('aria-busy', 'true');
      botonBuscar.disabled = true;
      estado.textContent = 'Buscando productos…';

      try {
        const respuesta = await fetch(url.toString(), {
          credentials: 'same-origin',
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        });

        if (!respuesta.ok) {
          throw new Error('No se pudo realizar la búsqueda');
        }

        const html = await respuesta.text();
        if (solicitudActual !== numeroSolicitud) return;

        const documento = new DOMParser().parseFromString(html, 'text/html');
        const cuadriculaEncontrada =
          documento.querySelector('.template-search__results ul.product-grid') ||
          documento.querySelector('.template-search ul.product-grid') ||
          documento.querySelector('main ul.product-grid');
        const cantidadProductos = cuadriculaEncontrada
          ? cuadriculaEncontrada.querySelectorAll(':scope > li').length
          : 0;

        if (cuadriculaEncontrada && cantidadProductos > 0) {
          cuadricula.innerHTML = cuadriculaEncontrada.innerHTML;
          agregarBotonesProductos(cuadricula);
        } else {
          cuadricula.innerHTML = `
            <li class="grid__item busqueda-catalogo__vacio">
              No encontramos productos con esa búsqueda.
            </li>
          `;
        }

        const paginacionEncontrada =
          documento.querySelector('.template-search__results .pagination-wrapper') ||
          documento.querySelector('.template-search .pagination-wrapper');

        paginacionBusqueda.innerHTML = paginacionEncontrada
          ? paginacionEncontrada.innerHTML
          : '';

        if (paginacionOriginal && paginacionOriginal !== paginacionBusqueda) {
          paginacionOriginal.style.display = 'none';
        }

        const contadorEncontrado =
          documento.querySelector('#ProductCountDesktop .product-count__text') ||
          documento.querySelector('#ProductCount .product-count__text') ||
          documento.querySelector('.template-search .product-count__text');

        modificarContador(
          seccion,
          contadorEncontrado
            ? contadorEncontrado.textContent.trim()
            : cantidadProductos === 1
              ? '1 resultado'
              : `${cantidadProductos} resultados`
        );

        estado.textContent = cantidadProductos > 0
          ? `Resultados para “${termino}”`
          : `No encontramos “${termino}”`;
      } catch (error) {
        console.error(error);
        estado.textContent = 'No se pudo completar la búsqueda. Inténtalo nuevamente.';
      } finally {
        if (solicitudActual === numeroSolicitud) {
          cuadricula.classList.remove('busqueda-cargando');
          cuadricula.removeAttribute('aria-busy');
          botonBuscar.disabled = false;
        }
      }
    }

    function crearURLBusqueda(termino, paginaURL = null) {
      const url = paginaURL
        ? new URL(paginaURL, window.location.origin)
        : new URL(RUTA_BUSQUEDA, window.location.origin);

      url.searchParams.set('q', termino);
      url.searchParams.set('type', 'product');
      url.searchParams.set('options[prefix]', 'last');

      return url;
    }

    formulario.addEventListener('submit', (evento) => {
      evento.preventDefault();

      const termino = campo.value.trim();
      const destino = crearURLCatalogoNavegacion(termino);

      if (termino) {
        sessionStorage.setItem(CLAVE_REGRESO, crearURLPublicaActual().href);
      } else {
        sessionStorage.removeItem(CLAVE_REGRESO);
      }

      window.location.assign(destino.href);
    });

    campo.addEventListener('input', () => {
      if (campo.value.trim() === '' && obtenerTerminoURL()) {
        window.location.assign(crearURLCatalogoNavegacion().href);
      }
    });

    document.addEventListener(
      'change',
      (evento) => {
        const control = evento.target;

        if (
          !obtenerTerminoURL() ||
          !control.matches?.('input[name^="filter."], select[name="sort_by"]')
        ) {
          return;
        }

        const formularioFiltros = control.closest('form');
        if (!formularioFiltros) return;

        evento.preventDefault();
        evento.stopImmediatePropagation();

        const destino = crearURLCatalogoNavegacion();
        const datos = new FormData(formularioFiltros);

        datos.forEach((valor, nombre) => {
          if (nombre.startsWith('filter.')) {
            destino.searchParams.append(nombre, valor);
          } else if (nombre === 'sort_by' && valor) {
            destino.searchParams.set(nombre, valor);
          }
        });

        sessionStorage.removeItem(CLAVE_REGRESO);
        window.location.assign(destino.href);
      },
      true
    );

    document.addEventListener('click', (evento) => {
      const enlaceProducto = evento.target.closest(
        '#ProductGridContainer a[href*="/products/"]'
      );

      if (enlaceProducto) {
        guardarPaginaActual();
      }
    });

    document.addEventListener('click', (evento) => {
      const enlace = evento.target.closest('.busqueda-paginacion a[href]');
      if (!enlace || !terminoActivo) return;

      evento.preventDefault();
      cargarBusqueda(crearURLBusqueda(terminoActivo, enlace.href), terminoActivo);

      formulario.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    botonCompartir.addEventListener('click', async () => {
      const urlCompartida = crearURLPublicaActual();
      const termino = obtenerTerminoURL();
      const haySeleccion = termino || hayFiltrosEnURL();
      const mensaje = termino
        ? `Mira los productos encontrados para “${termino}”`
        : haySeleccion
          ? 'Mira esta selección de productos de nuestro catálogo'
          : 'Revisa nuestro catálogo de productos';

      try {
        if (navigator.share) {
          await navigator.share({
            title: termino ? `Resultados para ${termino}` : document.title,
            text: mensaje,
            url: urlCompartida.href
          });
        } else if (navigator.clipboard) {
          await navigator.clipboard.writeText(urlCompartida.href);
          estado.textContent = haySeleccion
            ? 'Enlace de la selección copiado.'
            : 'Enlace del catálogo copiado.';
        } else {
          window.prompt('Copia este enlace:', urlCompartida.href);
        }
      } catch (error) {
        if (error.name !== 'AbortError') {
          window.prompt('Copia este enlace:', urlCompartida.href);
        }
      }
    });

    const terminoCompartido = obtenerTerminoURL();

    if (terminoCompartido) {
      campo.value = terminoCompartido;
      terminoActivo = terminoCompartido;
      guardarPaginaActual();
      cargarBusqueda(crearURLBusqueda(terminoCompartido), terminoCompartido);
    } else {
      campo.value = '';
      guardarPaginaActual();
    }

    actualizarBotonCompartir();

    document.addEventListener('change', () => {
      window.setTimeout(() => {
        actualizarBotonCompartir();
        guardarPaginaActual();
      }, 500);
    });

    window.addEventListener('popstate', () => {
      actualizarBotonCompartir();
      guardarPaginaActual();
    });
  }

  function iniciarCatalogosBalper() {
    document
      .querySelectorAll('[data-balper-catalog-search]')
      .forEach((formulario) => iniciarCatalogoBalper(formulario));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciarCatalogosBalper);
  } else {
    iniciarCatalogosBalper();
  }

  document.addEventListener('shopify:section:load', iniciarCatalogosBalper);
})();
